function dialog_Init(params) {
	if (Static.sock) dialog_InitExec(params);
	else {
		var id = window.setInterval(function() {
			if (Static.sock) {dialog_InitExec(params); clearInterval(id);}
		}, 100);
	}
}
function dialog_InitExec(params) {
	var defaults = {active: false, count_new: 0};
	Static.dialog = $.extend(defaults, params);
	Static.dialog.send = false;

	/*var h = $(window).height() - 350;
	$('#dialog-container').css('height', h > 500 ? 500 : h);*/

	var message = $('#dialog-message');
	if (message.length) {
		message.focus();
		message[0].onkeypress = dialog_Key;
		backup(message, 'dialog' + Static.dialog.id);
	}

	Static.sock.bind('here', function(data) {
		Static.dialog.here = data.here;
		if (data.here) $('li.sent').removeClass('sent');
	});

	Static.sock.send({action: 'subscribe_dialog', dialog_id: Static.dialog.id});

	Static.sock.bind('history', function(data) {
		$('#loading').remove();
		var first = !Static.dialog.posts;
		$("<li class='div'></li>").prependTo('.dialog');
		for (var i = 0; i < data.messages.length; i++) dialog_renderPost(data.messages[i], params.unread_date);
		$('.dialog li[class=load]').prependTo('.dialog').show();
		if (first) {
			/*$('#dialog-container').scrollTo($('.dialog').height() + 500, 200);
			$('#dialog-container').imagesLoaded(function() {$('#dialog-container').scrollTo($('.dialog').height() + 500, 200);});*/
			var w = $(window);
			w.scrollTo($('.dialog').height() - w.height() + 350, 0);
			$('#dialog-container').imagesLoaded(function() {w.scrollTo($('.dialog').height() - w.height() + 350, 0); $('#user-bar').removeClass('heads-up');});
		}
	});

	Static.sock.bind('error', function(data) {
		var error = data.error;
		if (error == 'dialog is deleted') error = 'Диалог удалён оппонентом';
		else if (error == 'you are foe') error = 'Вы добавлены во враги';
		else if (error == 'you are banner') error = 'Вы забанены';

		dialog_info(error)
		Static.dialog.send = false;
		$("#dialog-form #loader").remove();
	});

	if (message.length) {
		message.blur(function() {Static.dialog.active = false;});
		message.focus(function() {
			if (!Static.dialog.active) {
				Static.dialog.active = true;
				Static.dialog.count_new = 0;
				document.title = Static.dialog.u[2] + '  |  Диалоги';
			}
		});
	}

	if (!params.posts) dialog_History();
	editor_initUploader(false);
	atWho_init();
}

function dialog_Send() {
	if (Static.dialog.send) return;
	var t = $('#dialog-message').val();
	if (t == '') return false;
	Static.sock.send({action: 'pm', text: t, dialog_id: Static.dialog.id, images: Static.images});
	Static.dialog.send = true;
	$("#dialog-form").append("<div id='loader'><img src='/resource/image/icon/ajax.gif'></div>");
	$("#dialog-form .right input").attr("disabled", true);

	return false;
}

function dialog_Key(evt) {
	var evt = (evt) ? evt : ((event) ? event : null);
	if (!Static.dialog.active) {
		Static.dialog.active = true;
		Static.dialog.count_new = 0;
		document.title = Static.dialog.u[2] + '  |  Диалоги';
	}

	if (evt.keyCode == 13 || evt.keyCode == 10) {
		if (evt.ctrlKey || evt.shiftKey) editor_apply($('#dialog-message')[0], "\n", '');
		else dialog_Send();
		evt.stopPropagation();
		return false;
	}
}

function dialog_renderPost(data, delivered) {
	Static.dialog.posts++;
	if (!data.date) {
		Static.dialog.total++;
		$('#dialog-total').html(Static.dialog.total);
	}

	var u = Static.user.id == data.user_id ? Static.dialog.me : Static.dialog.u;
	if (Static.dialog.send && Static.user.id == data.user_id) {
		Static.dialog.send = false;
		$("#dialog-form #loader").remove();
		$("#dialog-form .right input").attr("disabled", false);
		$('#post-images').html('');
		Static.images = [];
		$('#dialog-message').val('');
		text_backup('dialog' + Static.dialog.id, '');
	}

	if (data.images) {
		if (data.images.length == 1) {
			var image = data.images[0];
			data.text += "<br><br><a href='" + image.link + image.ext + "' class='highslide'><img src='" + image.link + image.ext + "' alt=''" + (image.width ? " width='" + image.width + "' height='" + image.height + "'" : "") + "/></a>";
		} else {
			data.text += "<ul class='post-images carusel'>";
			$.each(data.images, function(idx, image) {
				data.text += "<li><a href='" + image.link + image.ext + "' class='highslide'><img src='" + image.link + "_48.jpg' width='48' height='48' alt=''/></a></li>";
			});
			data.text += "</ul>";
			data.text += "<small><a href='#' class='js' onClick='return thread_expandImages(" + data.id + ", this);'>раскрыть все картинки</a></small>";
		}
	}

	var is_unread = delivered === false || delivered == undefined || (data.date && delivered && delivered <= data.date);
	var $m = $("<li id='post-" + data.id + "'" + (is_unread ? " class='sent'" : '') + (data.id ? " data-id='" + data.id + "'" : '') + "><div class='user-small'><div class='avatar'>" + u[0] + "</div><div class='text'>" + u[1] + "<small> &nbsp; " + (data.date ? date_Full(data.date) : date_Full(new Date())) + "</small><br>" + data.text + "</div></div></li>");

	if (data.date) {
		$m.prependTo('.dialog');
	} else {
		$m.hide().appendTo('.dialog').fadeIn('fast');

		if (window.scrollY > $('#dialog-container').height() - 900)
			$(window).scrollTo($m, 200);
	}
	if (data.images) nbl.l("/resource/js/imagelightbox.min.js", lightbox_init);
}

function dialog_History() {
	var $last = $('.dialog li[class!=load]:first');
	$('.dialog li[class=load]').hide();

	Static.sock.send({action: 'history', dialog_id: Static.dialog.id, id: $last.data('id')});

	return false;
}

function dialog_Delete(id, event) {
	$('#static-content').dialog({
		title: 'Удалить или скрыть?',
		text: 'При скрытии диалога, он пропадает из общего списка, но продолжает быть активным и если оппонент что-нибудь вам напишет, то диалог перестанет быть скрытым.<br>При удалении, оппонент не сможет вам написать.',
		buttons: {
			'delete': ['submit', 'Удалить навсегда'],
			'hide':   ['submit', 'Скрыть'],
			'cancel': ['cancel', 'Отмена']
		},
		ajax: false,
		onSubmit: function() {
			var permanent = false;
			if (this.submited == 'field-delete') {
				permanent = true;
			}
			$.get('/pm?dialog=' + id + '&section=delete' + (permanent ? '&permanent' : ''));
			$('#d-' + id).fadeOut('fast');
			$.dialog_Hide();
		}
	});
	event.stopPropagation();
	return false;
}

function dialog_UnDelete(id, event) {
	$.get('/pm?dialog=' + id + '&section=undelete');
	redirect('/pm');
	event.stopPropagation();
	return false;
}

function dialog_renderNotify(data) {
	data.u_id = data.user_id;
	var m = "<div class='clear'><h1>Новое сообщение</h1></div><br><div class='clear'>" + user_getAvatar(data, 48) + "<div class='text'>" + user_getLink(data) + "<br>" + data.text + "</div></div>";
	renderNotify(data.u_login, m, '/pm/?dialog=' + data.dialog_id);
}
